module.exports = __webpack_public_path__ + "img/Artboard3.eaf02835.webp";